import { render } from "./underwriter-config-addgroup.vue?vue&type=template&id=0f04fda2&lang=html"
import script from "./underwriter-config-addgroup.vue?vue&type=script&lang=js"
export * from "./underwriter-config-addgroup.vue?vue&type=script&lang=js"

import "./underwriter-config-addgroup.vue?vue&type=style&index=0&id=0f04fda2&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__